import React from 'react';
import { useAuthStateSync } from '../../hooks/useAuthStateSync';

interface AuthStateManagerProps {
  children: React.ReactNode;
}

/**
 * Component that manages authentication state synchronization
 * Ensures Redux state stays synchronized with DirectusAuthManager
 */
export const AuthStateManager: React.FC<AuthStateManagerProps> = ({ children }) => {
  // Initialize auth state synchronization
  useAuthStateSync();

  return <>{children}</>;
};